import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonComponent, DatePickerComponent, ModalData, ModalRef } from '@ui-lib/components';
import { IExportDayModalData } from './export-day-modal.model';

@Component({
  standalone: true,
  selector: 'mon-export-day-modal',
  templateUrl: './export-day-modal.component.html',
  styleUrl: './export-day-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ButtonComponent, DatePickerComponent, ReactiveFormsModule, TranslateModule],
})
export class ExportDayModalComponent extends ModalData<IExportDayModalData> {
  private readonly modalRef = inject(ModalRef<Date>);

  protected readonly dayControl = new FormControl<Date | [Date, Date] | null>(
    this.modalData.earliestDate === null ? null : this.modalData.latestDate,
  );

  protected get selectedDay(): Date | null {
    const value = this.dayControl.value;

    return value instanceof Date ? value : null;
  }

  protected cancel(): void {
    this.modalRef.close();
  }

  protected confirm(): void {
    const day = this.selectedDay;

    if (day === null) {
      return;
    }

    this.modalRef.close(day);
  }
}
